import Parentui from "../pages/Teachable";
import Layout from "../layout/Layout";

const Home = () => {
  return(
    <Layout>
    <Parentui/>
    </Layout>
  );
};
export default Home;